/*jslint unparam: true, browser: true, indent: 2 */

;(function ($, window, document, undefined) {
  'use strict';

  Foundation.libs.menubar = {
    name : 'menubar',

    version: '4.3.2',

    settings : {
      index : 0,
      stickyClass : 'sticky',
      custom_back_text: true,
      back_text: 'Back',
      is_hover: true,
      mobile_show_parent_link: false,
      scrolltop : true, // jump to top when sticky nav menu toggle is clicked
      init : false
    },

    init : function (section, method, options) {
      Foundation.inherit(this, 'data_options addCustomRule');
      var self = this;

      if (typeof method === 'object') {
        $.extend(true, this.settings, method);
      } else if (typeof options !== 'undefined') {
        $.extend(true, this.settings, options);
      }

      if (typeof method !== 'string') {

        $('.menubar, [data-menubar]').each(function () {
          $.extend(true, self.settings, self.data_options($(this)));
          self.settings.$w = $(window);
          self.settings.$menubar = $(this);
          self.settings.$section = self.settings.$menubar.find('section');
          self.settings.$titlebar = self.settings.$menubar.children('ul').first();
          self.settings.$menubar.data('index', 0);

          var menubarContainer = self.settings.$menubar.parent();
          if(menubarContainer.hasClass('fixed') || menubarContainer.hasClass(self.settings.stickyClass)) {
            self.settings.$menubar.data('height', self.outerHeight(menubarContainer));
            self.settings.$menubar.data('stickyoffset', menubarContainer.offset().top);
          } else {
            self.settings.$menubar.data('height', self.outerHeight(self.settings.$menubar));
          }

          var breakpoint = $("<div class='menubar-js-breakpoint'/>").insertAfter(self.settings.$menubar);
          self.settings.breakPoint = breakpoint.width();
          breakpoint.remove();

          self.assemble();

          if (self.settings.is_hover) {
            self.settings.$menubar.find('.has-dropdown').addClass('not-click');
          }

          // >> Custom - Add inPath class for nav nodes
          self.settings.$menubar.find('.menubar__item--here').parents('.has-dropdown').addClass('menubar__item--inPath');
          // << Custom

          // Pad body when sticky (scrolled) or fixed.
          self.addCustomRule('.f-menubar-fixed { padding-top: ' + self.settings.$menubar.data('height') + 'px }');

          if (self.settings.$menubar.parent().hasClass('fixed')) {
            $('body').addClass('f-menubar-fixed');
          }
        });

        if (!self.settings.init) {
          this.events();
        }

        return this.settings.init;
      } else {
        // fire method
        return this[method].call(this, options);
      }
    },

    toggle: function() {
      var self = this;
      var menubar = $('.menubar, [data-menubar]'),
          section = menubar.find('section, .section');

      if (self.breakpoint()) {
        if (!self.rtl) {
          section.css({left: '0%'});
          section.find('>.name').css({left: '100%'});
        } else {
          section.css({right: '0%'});
          section.find('>.name').css({right: '100%'});
        }

        section.find('li.moved').removeClass('moved');
        menubar.data('index', 0);

        menubar
          .toggleClass('expanded')
          .css('height', '');
      }

      if(self.settings.scrolltop)
      {
        if (!menubar.hasClass('expanded')) {
          if (menubar.hasClass('fixed')) {
            menubar.parent().addClass('fixed');
            menubar.removeClass('fixed');
            $('body').addClass('f-menubar-fixed');
          }
        } else if (menubar.parent().hasClass('fixed')) {
          if (self.settings.scrolltop) {
            menubar.parent().removeClass('fixed');
            menubar.addClass('fixed');
            $('body').removeClass('f-menubar-fixed');

            window.scrollTo(0,0);
          } else {
              menubar.parent().removeClass('expanded');
          }
        }
      } else {
        if(menubar.parent().hasClass(self.settings.stickyClass)) {
          menubar.parent().addClass('fixed');
        }

        if(menubar.parent().hasClass('fixed')) {
          if (!menubar.hasClass('expanded')) {
            menubar.removeClass('fixed');
            menubar.parent().removeClass('expanded');
            self.updateStickyPositioning();
          } else {
            menubar.addClass('fixed');
            menubar.parent().addClass('expanded');
          }
        }
      }
    },

    timer : null,

    events : function () {
      var self = this;
      $(this.scope)
        .off('.fndtn.menubar')
        .on('click.fndtn.menubar', '.menubar .menubar__toggle, [data-menubar] .menubar__toggle', function (e) {
          e.preventDefault();
          self.toggle();
        })

        .on('click.fndtn.menubar', '.menubar li.has-dropdown', function (e) {
          var li = $(this),
              target = $(e.target),
              menubar = li.closest('[data-menubar], .menubar'),
              is_hover = menubar.data('menubar');

          if(target.data('revealId')) {
            self.toggle();
            return;
          }

          // Custom - Check for href #; href with # make problems on waf urls
          if (target[0].nodeName === 'A' && target.parent().hasClass('has-dropdown') && target.attr('href') == '#') {
            e.preventDefault();
          }
          // Custom

          if (self.breakpoint()) return;
          if (self.settings.is_hover && !Modernizr.touch) return;

          e.stopImmediatePropagation();

          if (target[0].nodeName === 'A' && target.parent().hasClass('has-dropdown')) {
            console.log('Test2');
            e.preventDefault();
          }

          if (li.hasClass('hover')) {
            li
              .removeClass('hover')
              .find('li')
              .removeClass('hover');

            li.parents('li.hover')
              .removeClass('hover');
          } else {
            li.addClass('hover');
          }
        })

        .on('click.fndtn.menubar', '.menubar .has-dropdown>a, [data-menubar] .has-dropdown>a', function (e) {
          if (self.breakpoint() && $(window).width() != self.settings.breakPoint) {

            e.preventDefault();

            var $this = $(this),
                menubar = $this.closest('.menubar, [data-menubar]'),
                section = menubar.find('section, .section'),
                dropdownHeight = $this.next('.menubar__dropdown').outerHeight(),
                $selectedLi = $this.closest('li');

            menubar.data('index', menubar.data('index') + 1);
            $selectedLi.addClass('moved');

            if (!self.rtl) {
              section.css({left: -(100 * menubar.data('index')) + '%'});
              section.find('>.name').css({left: 100 * menubar.data('index') + '%'});
            } else {
              section.css({right: -(100 * menubar.data('index')) + '%'});
              section.find('>.name').css({right: 100 * menubar.data('index') + '%'});
            }

            menubar.css('height', self.outerHeight($this.siblings('ul'), true) + self.settings.$menubar.data('height'));
          }
        });

      $(window).on('resize.fndtn.menubar', function () {
        if (typeof self.settings.$menubar === 'undefined') { return; }
        var stickyContainer = self.settings.$menubar.parent('.' + this.settings.stickyClass);
        var stickyOffset;

        if (!self.breakpoint()) {
          var doToggle = self.settings.$menubar.hasClass('expanded');
          $('.menubar, [data-menubar]')
            .css('height', '')
            .removeClass('expanded')
            .find('li')
            .removeClass('hover');

            if(doToggle) {
              self.toggle();
            }
        }

        if(stickyContainer.length > 0) {
          if(stickyContainer.hasClass('fixed')) {
            // Remove the fixed to allow for correct calculation of the offset.
            stickyContainer.removeClass('fixed');

            stickyOffset = stickyContainer.offset().top;
            if($(document.body).hasClass('f-menubar-fixed')) {
              stickyOffset -= self.settings.$menubar.data('height');
            }

            self.settings.$menubar.data('stickyoffset', stickyOffset);
            stickyContainer.addClass('fixed');
          } else {
            stickyOffset = stickyContainer.offset().top;
            self.settings.$menubar.data('stickyoffset', stickyOffset);
          }
        }
      }.bind(this));

      $('body').on('click.fndtn.menubar', function (e) {
        var parent = $(e.target).closest('li').closest('li.hover');

        if (parent.length > 0) {
          return;
        }

        $('.menubar li, [data-menubar] li').removeClass('hover');
      });

      // Go up a level on Click
      $(this.scope).on('click.fndtn', '.menubar .has-dropdown .back, [data-menubar] .has-dropdown .back', function (e) {
        e.preventDefault();

        var $this = $(this),
            menubar = $this.closest('.menubar, [data-menubar]'),
            section = menubar.find('section, .section'),
            $movedLi = $this.closest('li.moved'),
            $previousLevelUl = $movedLi.parent();

        menubar.data('index', menubar.data('index') - 1);

        if (!self.rtl) {
          section.css({left: -(100 * menubar.data('index')) + '%'});
          section.find('>.name').css({left: 100 * menubar.data('index') + '%'});
        } else {
          section.css({right: -(100 * menubar.data('index')) + '%'});
          section.find('>.name').css({right: 100 * menubar.data('index') + '%'});
        }

        if (menubar.data('index') === 0) {
          menubar.css('height', '');
        } else {
          menubar.css('height', self.outerHeight($previousLevelUl, true) + self.settings.$menubar.data('height'));
        }

        setTimeout(function () {
          $movedLi.removeClass('moved');
        }, 300);
      });
    },

    breakpoint : function () {
      return $(document).width() <= this.settings.breakPoint || $('html').hasClass('lt-ie9');
    },

    assemble : function () {
      var self = this;
      // Pull element out of the DOM for manipulation
      this.settings.$section.detach();

      this.settings.$section.find('.has-dropdown>a').each(function () {
        var $link = $(this),
            $dropdown = $link.siblings('.menubar__dropdown'),
            url = $link.attr('href');

        if (self.settings.mobile_show_parent_link && url && url.length > 1) {
          var $titleLi = $('<li class="back js-generated"><a href="#"></a></li><li><a class="parent-link js-generated" href="' + url + '">' + $link.text() +'</a></li>');
        } else {
          var $titleLi = $('<li class="back js-generated"><a href="#"></a></li>');
        }

        // Copy link to subnav
        if (self.settings.custom_back_text == true) {
          $titleLi.find('> a').html(self.settings.back_text);
        } else {
          $titleLi.find('> a').html('&laquo; ' + $link.html());
        }
        $dropdown.prepend($titleLi);
      });

      // Put element back in the DOM
      this.settings.$section.appendTo(this.settings.$menubar);

      // check for sticky
      this.sticky();
    },

    height : function (ul) {
      var total = 0,
          self = this;

      ul.find('> li').each(function () { total += self.outerHeight($(this), true); });

      return total;
    },

    sticky : function () {
      var $window = $(window),
          self = this;

      $window.scroll(function() {
        self.updateStickyPositioning();
      });
    },

    updateStickyPositioning: function() {
      var klass = '.' + this.settings.stickyClass;
      var $window = $(window);

      if ($(klass).length > 0) {
        var distance = this.settings.$menubar.data('stickyoffset');
        if (!$(klass).hasClass('expanded')) {
          if ($window.scrollTop() > (distance)) {
            if (!$(klass).hasClass('fixed')) {
              $(klass).addClass('fixed');
              $('body').addClass('f-menubar-fixed');
            }
          } else if ($window.scrollTop() <= distance) {
            if ($(klass).hasClass('fixed')) {
              $(klass).removeClass('fixed');
              $('body').removeClass('f-menubar-fixed');
            }
          }
        }
      }
    },

    off : function () {
      $(this.scope).off('.fndtn.menubar');
      $(window).off('.fndtn.menubar');
    },

    reflow : function () {}
  };
}(Foundation.zj, window, window.document));
